export class BaseModel {
    constructor(data: any) {
        Object.assign(this, data);
    }
}
